import React, { useEffect, useState } from "react";
import { BreadcrumbIcon } from "../../Assets/Icons";

const Breadcrumbs = ({ data = [], handleClick, activeCrumb, maxCount = 3 }) => {
  const [crumbData, setCrumbData] = useState([]);

  const handleBreadClick = (value) => {
    const index = data.findIndex((item) => item.key === value.key);
    setCrumbData(data.slice(0, index + 1));
    if (handleClick) {
      handleClick(value);
    }
  };

  useEffect(() => {
    if (data.length && activeCrumb) {
      const index = data.findIndex((item) => item.key === activeCrumb);
      setCrumbData(data.slice(0, index + 1));
    }
  }, [data.length, activeCrumb]);

  return (
    <div className="breadcrumbs">
      {crumbData.length > maxCount ? (
        <>
          <span onClick={() => handleBreadClick(crumbData[0])}>
            {" "}
            <p> {crumbData[0]?.title} </p> <BreadcrumbIcon />{" "}
          </span>

          <div className="bread-drop">
            <div className="dropdown">
              <div className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                ...
              </div>
              <div className="dropdown-menu">
                <div className="colorborder">
                  {crumbData?.map(
                    (item, idx) =>
                      idx !== 0 &&
                      idx !== crumbData?.length - 1 && <p onClick={() => handleBreadClick(item)}>{item?.title}</p>
                  )}
                </div>
              </div>
            </div>
            <BreadcrumbIcon />
          </div>
          <span className="active" onClick={() => handleBreadClick(crumbData[crumbData?.length - 1])}>
            <p> {crumbData[crumbData?.length - 1]?.title} </p>
          </span>
        </>
      ) : (
        crumbData?.map((item, idx) => {
          if (idx !== crumbData?.length - 1) {
            return (
              <span onClick={() => handleBreadClick(item)}>
                {" "}
                <p> {item?.title} </p> <BreadcrumbIcon />{" "}
              </span>
            );
          } else {
            return (
              <span className="active" onClick={() => handleBreadClick(item)}>
                {" "}
                <p> {item.title} </p>
              </span>
            );
          }
        })
      )}
    </div>
  );
};

export default Breadcrumbs;
